import {
  AfterViewInit, Directive, ElementRef, inject, input,
  OnDestroy,
  output
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { goToDetails } from '../../utils/navigation/go-to-details';

interface Element {
  id: number;
  type: string;
}

@Directive({
  selector: '[go-to-details]',
  standalone: true,
})
export class GoToDetailsDirective implements AfterViewInit, OnDestroy {
  element = input<Element>();

  type = input<string>();

  queryParams = input<Record<string, unknown>>();

  mode = input<"modal" | "route">('modal');

  afterClosed = output<void>();


  handler: ((event: Event) => void) = undefined;


  dialog = inject(MatDialog);

  domElementRef = inject(ElementRef);

  router = inject(Router);
 

  ngAfterViewInit(): void {
    const fn = (event: Event) => {
      event.stopPropagation();

      if (this.mode() === 'route') {
        this.dialog.closeAll();
      }

      goToDetails({
        id: this.element().id,
        type: this.element().type || this.type(),
        mode: this.mode(),
        afterClosed: this.afterClosed,
        queryParams: this.queryParams(),
        dialog: this.dialog,
        router: this.router,
      });
    };
    this.domElementRef.nativeElement.addEventListener('click', fn);

    this.handler = fn;
  }

  ngOnDestroy(): void {
    this.domElementRef.nativeElement.removeEventListener('click', this.handler);
  }

}
